import Sortable from 'sortablejs';
import Helpers from '../../../../bademoden-haendler/src/js/helpers/helpers'

export class ProspectForm {
    storageNameUploadedLogo: string = 'riedl_prospect_logo';
    storageNameSelectedPage: string = 'riedl_prospect_selected_pages';
    generatorWrapperClass: string = 'riedl-progen__items-wrapper';
    generatorWrapperRowClass: string = 'riedl-progen__items-wrapper-row';
    itemClass: string = 'riedl-progen__item';
    itemTitleClass: string = 'riedl-progen__item__title';
    itemThumbnailWrapperClass: string = 'riedl-progen__item__thumbnail';
    itemInputWrapperClass: string = 'riedl-progen__item__input';
    itemEditButtonClass: string = 'riedl-progen__item__edit';
    itemDeleteButtonClass: string = 'riedl-progen__item__delete';
    buttonLoadingClass: string = 'is-loading';
    addButtonId: string = 'riedl-progen__add_item';
    resetButtonId: string = 'riedl-progen__reset-generator';
    startNewSectionId: string = 'riedl_progen__start-new-section';
    generatePdfButtonId: string = 'riedl-progen__generate';
    downloadReadyAlertId: string = 'riedl-progen__download-ready';
    downloadButtonId: string = 'riedl-progen__download';
    downloadJpgButtonId: string = 'riedl-progen__download-jpg';
    coverLogoFormId: string = 'riedl-progen__logo-upload__form';
    coverLogoInput: string = 'riedl-progen__logo-upload__input';
    coverLogoUploadDeleteButton: string = 'riedl-progen__logo-upload__delete';
    coverLogoImageWrapperClass: string = 'cover-logo-wrapper';
    logoUploadedInputId: string = 'riedl-progen__logo-upload--is-uploaded';
    pagesPreviewLetsgoButtonId = 'letsgo';
    pagesPreviewCloseButtonId = 'cancel';
    pagesPreviewAddPageFormId: string = 'progen-preview-add-pages';
    pagesPreviewGridId: string = 'prospect-pages-preview';
    pagesPreviewBrandWrapperClass: string = 'prospect-preview';
    pagesPreviewSelectBrandDropdownId = 'riedl-progen__select-brand';
    pagesPreviewItemClass: string = 'collection-list';
    items: Array<any> = [];
    selectedEditItemIndexForEditModal: string = '';
    generatedPdfUrl: string = '';
    selectedEditItemPageIdForModal: any = '';

    constructor() {
        if (jQuery(`#${this.generatorWrapperClass}`).length === 0) return;

        this.setupProspectGenerator()
        this.renderItems();
        this.handleEvents();
    }

    async setupProspectGenerator() {
        // this.deleteSessionStorageKey(this.storageNameUploadedLogo);
        // this.deleteSessionStorageKey(this.storageNameSelectedPage);

        const selectedPagesInCookie = this.getFromSessionStorage(this.storageNameSelectedPage);
        if (selectedPagesInCookie && JSON.parse(selectedPagesInCookie)) {
            this.items = JSON.parse(selectedPagesInCookie);

            if (this.items.length > 0) {
                jQuery(`#${this.generatePdfButtonId}`).removeAttr('hidden');
            }
        }

        const uploadedLogoCookie = this.getFromSessionStorage(this.storageNameUploadedLogo);
        if (uploadedLogoCookie) {
            const logoBlob = await jQuery.ajax({
                method: 'POST',
                url: window.riedlBamoHaendlerConfig.ajaxUrl,
                data: {
                    action: 'riedl_prospect_generator_get_logo',
                    fileName: uploadedLogoCookie,
                },
            })

            // console.log('CHECK BLOB', logoBlob)

            if (logoBlob.success) {
                this.setUploadedLogo(uploadedLogoCookie, logoBlob.data.imageBlob);
            }

        }
    }

    handleEvents() {
        const root = this;

        // jQuery(document).on('click', `#${this.addButtonId}`, (e) => {
        //     console.log('ADD Button clicked');
        //
        //     this.addItem();
        //     this.renderItems();
        // });

        // jQuery(document).on('submit', `#${this.coverLogoFormId}`, async (e) => {
        //     e.preventDefault();
        //     console.log('Cover logo submitted');
        //
        //     jQuery(e.currentTarget).find(`#${this.coverLogoFormId}`).addClass(this.buttonLoadingClass);
        //
        //     await this.uploadLogo(e);
        // });

        jQuery(document).on('change', `#${this.coverLogoInput}`, async (e) => {
            await this.uploadLogo(e)
        })

        jQuery(document).on('click', `#${this.generatePdfButtonId}`, async (e) => {
            e.preventDefault();

            if (Helpers.isDebugMode()) {
                console.log(`Button #${this.generatePdfButtonId} clicked`)
            }

            await this.generatePdf(e);
        })

        jQuery(document).on('click', `#${this.downloadButtonId}`, async (e) => {
            e.preventDefault();

            if (Helpers.isDebugMode()) {
                console.log(`Button #${this.downloadButtonId} clicked`)
            }

            await this.downloadProspect(e);
        })

        jQuery(document).on('click', `#${this.downloadJpgButtonId}`, async (e) => {
            e.preventDefault();
            await this.downloadJpgImages(e);
        })

        jQuery(document).on('click', `.${this.itemEditButtonClass}`, (e) => {
            e.preventDefault();
            // console.log(`Edit button clicked`, jQuery(e.currentTarget).attr('data-id'));

            this.onPageItemEditClicked(e);
        });

        jQuery(document).on('click', `.${this.itemDeleteButtonClass}`, (e) => {
            e.preventDefault();
            // console.log(`Delete button clicked`, jQuery(e.currentTarget).attr('data-id'));
            this.onPageItemDeleteClicked(e);
        });

        // jQuery(document).on('click', `#${this.pagesPreviewGridId} .${this.pagesPreviewItemClass}`, (e) => {
        //     e.preventDefault();
        //     this.onPreviewPageClicked(e);
        // })

        jQuery(document).on('click', `#${this.resetButtonId}`, (e) => {
            e.preventDefault();
            this.resetGenerator(e);
        })

        jQuery(document).on('click', `#${this.coverLogoUploadDeleteButton}`, (e) => {
            e.preventDefault();
            this.onDeleteLogoButton(e);
        })

        jQuery(document).on('submit', `#${this.pagesPreviewAddPageFormId}`, (e) => {
            e.preventDefault();

            if (Helpers.isDebugMode()) {
                console.log('Add button clicked');
            }

            this.onAddPagesInModal(e);
        })

        jQuery(document).on('click', `#${this.pagesPreviewSelectBrandDropdownId} .dropdown-content a`, (event) => {
            event.preventDefault();

            this.onChangeModalSelectBrand(event);
        })

        jQuery(document).on('change keyup', `.${this.itemInputWrapperClass} input[name="prospect_page_id[]"]`, (event) => {

            setTimeout(() => {
                const itemRow = jQuery(event.currentTarget).closest(`.${this.itemClass}`)

                this.renderItemThumbnail(itemRow);

            }, 500);
        });

        jQuery('#prospect-pages').on('popupIsOpening', (event) => {

            if (Helpers.isDebugMode()) {
                console.log('Popup will open', event);
            }

            this.onPopupOpened(event);
        })

        jQuery('#prospect-pages').on('popupClosed', (event) => {

            if (Helpers.isDebugMode()) {
                console.log('Popup closed', event);
            }

            this.onPopupClosed(event);
        });

        new Sortable(document.getElementById(root.generatorWrapperClass), {
            // name: String — group name
            // pull: true|false|["foo", "bar"]|'clone'|function — ability to move from the list. clone — copy the item, rather than move. Or an array of group names which the elements may be put in. Defaults to true.
            // put: true|false|["baz", "qux"]|function — whether elements can be added from other lists, or an array of group names from which elements can be added.
            // revertClone: boolean — revert cloned element to initial position after moving to a another list.
            // group: "name",  // or { name: "...", pull: [true, false, 'clone', array], put: [true, false, array] }
            // // enable sorting
            // sort: true,
            // // time to wait before the sorting should start
            // delay: 0,
            // // enable delay on touch
            // delayOnTouchOnly: false,
            // // how many pixels the point should move before cancelling a delayed drag event
            // touchStartThreshold: 0,
            // // disables the sortable if set to true.
            // disabled: false,
            // // which items inside the element should be draggable
            // draggable: '>*',
            // // save and restore the sort.
            // store: null,
            // // animation speed
            animation: 150,
            // // easing function: "cubic-bezier(1, 0, 0, 1)"
            // easing: null,
            // // drag handle
            handle: ".riedl-progen__item__handle",

            // // elements to ignore
            // ignore: 'a, img',
            // // filter selector
            // filter: ".riedl-progen__item__title",
            // // preverntDefault when filtering
            // preventOnFilter: true,

            // // drop placeholder
            // ghostClass: "sortable-ghost",
            // // chosen class
            // chosenClass: "sortable-chosen",
            // // dragging class
            // dragClass: "sortable-drag",
            // // default data attribute
            // dataIdAttr: 'data-id',
            // // enable drop bubble
            // dropBubble: true,


            // // threshold of the swap zone
            // swapThreshold: 1,
            // // invert swap
            // invertSwap: true,


            // // threshold of the inverted swap zone
            // invertedSwapThreshold: 1,
            // // will be detected automatically if not given
            // direction: 'vertical',


            // // ignore the HTML5 DnD behaviour
            // forceFallback: false,
            // // fallback class
            // fallbackClass: "sortable-fallback",
            // // appends the cloned DOM Element into the document body
            // fallbackOnBody: false,
            // // how far the mouse should move before it's considered as a drag.
            // fallbackTolerance: 0,
            // // fallback offsets
            // fallbackOffset: {
            //     x: 0,
            //     y: 0
            // },
            // dragoverBubble: true,


            // remove the cloned element when it is not showing
            // removeCloneOnHide: true,
            // distance mouse must be from empty sortable to insert drag element into it
            // emptyInsertThreshold: 5, // px,
            // set data
            // setData: function (/** DataTransfer */dataTransfer, /** HTMLElement*/dragEl) {
            //     dataTransfer.setData('Text', dragEl.textContent); // `dataTransfer` object of HTML5 DragEvent
            // },
            // scroll plugin options
            // Enable the plugin. Can be HTMLElement.
            // scroll: true,
            // if you have custom scrollbar scrollFn may be used for autoscrolling
            // scrollFn: function (offsetX, offsetY, originalEvent, touchEvt, hoverTargetEl) {
            // },
            // px, how near the mouse must be to an edge to start scrolling.
            // scrollSensitivity: 30,
            // force auto scroll fallback
            // forceAutoScrollFallback: false,
            // px, speed of the scrolling
            // scrollSpeed: 10,
            // apply autoscroll to all parent elements, allowing for easier movement
            // bubbleScroll: true,
            // OnSpill Plugin options
            // Enable plugin
            // revertOnSpill: true,
            // Called when item is spilled
            // onSpill: function (/**Event*/evt) {
            //     evt.item // The spilled item
            // },
            // MultiDrag Plugin options
            // Enable the plugin
            // multiDrag: true,
            // Class name for selected item
            // selectedClass: "sortable-selected",
            // Key that must be down for items to be selected
            // multiDragKey: null,
            // Called when an item is selected
            // onSelect: function (/**Event*/evt) {
            //     evt.item // The selected item
            //     console.log('onSelect');
            // },
            // Called when an item is deselected
            // onDeselect: function (/**Event*/evt) {
            //     evt.item // The deselected item
            // },
            // Swap Plugin options
            // Enable swap mode
            // swap: true,
            // Class name for swap item (if swap mode is enabled)
            // swapClass: "sortable-swap-highlight",
            // Element is chosen
            // onChoose: function (/**Event*/evt) {
            //     evt.oldIndex;  // element index within parent
            //     console.log('onChoose');
            // },
            // Element is unchosen
            // onUnchoose: function (/**Event*/evt) {
            //     // same properties as onEnd
            // },
            // Element dragging started
            // onStart: function (/**Event*/evt) {
            //     evt.oldIndex;  // element index within parent
            // },
            // Element dragging ended
            // onEnd: function (/**Event*/evt) {
            //     // @ts-ignore
            //     var itemEl = evt.item;  // dragged HTMLElement
            //     evt.to;    // target list
            //     evt.from;  // previous list
            //     evt.oldIndex;  // element's old index within old parent
            //     evt.newIndex;  // element's new index within new parent
            //     evt.clone // the clone element
            //     evt.pullMode;  // when item is in another sortable: `"clone"` if cloning, `true` if moving
            // },
            // Element is dropped into the list from another list
            // onAdd: function (/**Event*/evt) {
            //     // same properties as onEnd
            // },
            // Changed sorting within list
            // onUpdate: function (/**Event*/evt) {
            //     // same properties as onEnd
            //     console.log('onUpdate');
            // },
            // Called by any change to the list (add / update / remove)
            onSort: function (/**Event*/evt) {
                // same properties as onEnd

                if (Helpers.isDebugMode()) {
                    console.log('onSort');
                }
                // root.toggleDownloadPdfButton(false);
                root.toggleGeneratePdfButton(true);
                root.saveItems();
                root.reRenderItems();
            },
            // Element is removed from the list into another list
            // onRemove: function (/**Event*/evt) {
            //     // same properties as onEnd
            // },
            // Attempt to drag a filtered element
            // onFilter: function (/**Event*/evt) {
            //     // @ts-ignore
            //     var itemEl = evt.item;  // HTMLElement receiving the `mousedown|tapstart` event.
            // },
            // Event when you move an item in the list or between lists
            // onMove: function (/**Event*/evt, /**Event*/originalEvent) {
            //     console.log('onMove');
            //     // Example: https://jsbin.com/nawahef/edit?js,output
            //     evt.dragged; // dragged HTMLElement
            //     evt.draggedRect; // DOMRect {left, top, right, bottom}
            //     evt.related; // HTMLElement on which have guided
            //     evt.relatedRect; // DOMRect
            //     evt.willInsertAfter; // Boolean that is true if Sortable will insert drag element after target by default
            //     originalEvent.clientY; // mouse position
            //     // return false; — for cancel
            //     // return -1; — insert before target
            //     // return 1; — insert after target
            // },
            // Called when creating a clone of element
            // onClone: function (/**Event*/evt) {
            //     console.log('onClone');
            //     // @ts-ignore
            //     var origEl = evt.item;
            //     // @ts-ignore
            //     var cloneEl = evt.clone;
            // },
            // Called when dragging element changes position
            // onChange: function (/**Event*/evt) {
            //     console.log('OnChange');
            //     evt.newIndex // most likely why this event is used is to get the dragging element's current index
            //     // same properties as onEnd
            // }
        });
    }

    onPopupOpened(popupEvent) {
        const previewPopupClass = 'popup--page-preview';
        const buttonPopupTypeAttr = 'data-popup-type'

        const popup = jQuery(popupEvent.currentTarget);
        // @ts-ignore
        const triggerButton = jQuery(popupEvent.detail?.button);
        popup.addClass(previewPopupClass);
        popup.find(`#${this.pagesPreviewCloseButtonId}`).hide();
        popup.find(`#${this.pagesPreviewLetsgoButtonId}`).hide();
        popup.find('button[type="submit"]').hide();
        popup.find('figure').removeClass('collection-list');
        popup.find('button[type="submit"]').removeAttr('data-is-edit');

        const headlineSelect = jQuery('#riedl-progen__headline--select');
        const textSelect = jQuery('#riedl-progen__text--select');
        const headlinePreview = jQuery('#riedl-progen__headline--preview');

        headlineSelect.hide()
        textSelect.hide()
        headlinePreview.hide()

        // @ts-ignore
        if (triggerButton.attr('data-brand-id')) {

            if (Helpers.isDebugMode()) {
                console.warn('triggerButton', triggerButton)
            }

            this.onChangeModalSelectBrand(null, triggerButton.attr('data-brand-id'))
        }

        if (triggerButton.attr(buttonPopupTypeAttr) === 'edit' || triggerButton.attr(buttonPopupTypeAttr) === 'add-page' || triggerButton.attr(buttonPopupTypeAttr) === 'preview') {
            headlineSelect.show()
            textSelect.show()

            popup.removeClass(previewPopupClass);
            popup.find('figure').addClass('collection-list');
            popup.find('button[type="submit"]').show();
            popup.find(`#${this.pagesPreviewCloseButtonId}`).show();
            popup.find(`#${this.pagesPreviewLetsgoButtonId}`).hide();
        }

        if (triggerButton.attr(buttonPopupTypeAttr) === 'edit') {
            const itemRow = triggerButton.closest(`.${this.itemClass}`);
            const itemValue = itemRow.find('input').val() ?? '';

            this.selectedEditItemPageIdForModal = itemValue;
            this.selectedEditItemIndexForEditModal = itemRow.data('index');

            popup.find('button[type="submit"]').attr('data-is-edit', 'true');
            this.togglePreviewItemByIdIndexActive(itemValue, true);

            popup.find('input[name="selected_page_ids[]"]').remove();
        }

        if (triggerButton.attr(buttonPopupTypeAttr) === 'preview') {
            // headlinePreview.show()
            // popup.find('#prospect_add_button').hide()
            // popup.find('#prospect_preview_add_button').show()
            // popup.find(`#${this.pagesPreviewLetsgoButtonId}`).show();
        }

        popup.on('click', `figure.${this.pagesPreviewItemClass}`, (itemEvent) => {
            this.onPreviewPageClicked(itemEvent, (triggerButton.attr(buttonPopupTypeAttr) === 'edit'), popup, triggerButton, buttonPopupTypeAttr);
            // this.togglePreviewPageItemForEditMode(itemEvent, popup, triggerButton, buttonPopupTypeAttr)
        })
    }

    onPopupClosed(popupEvent) {
        const popup = jQuery(popupEvent.currentTarget);
        popup.find('input[name="selected_page_ids[]"]').remove();
        popup.find('figure').attr('data-selected', 'false').removeClass('active');
        // popup.find('button[type="submit"]').hide();
        // popup.find('figure').removeClass('collection-list');

        popup.off('click', `figure.${this.pagesPreviewItemClass}`);

        this.resetSelectPageModal()

        setTimeout(() => {
            this.selectedEditItemIndexForEditModal = "";

            popup.find('button[type="submit"]').removeAttr('data-is-edit');
        }, 1000)
    }

    togglePreviewPageItemForEditMode(itemEvent, popup, triggerButton, buttonPopupTypeAttr) {
        const item = jQuery(itemEvent.currentTarget);

        if (Helpers.isDebugMode()) {
            console.warn('togglePreviewPageItemForEditMode() => triggerButton', triggerButton, 'ATTR', triggerButton.attr(buttonPopupTypeAttr));
        }

        if (triggerButton.attr(buttonPopupTypeAttr) !== 'edit') return;

        if (Helpers.isDebugMode()) {
            console.log('Item CLICKED in EDIT mode', item)
        }

        // popup.find('input[name="selected_page_ids[]"]').remove();
        // popup.find('figure').attr('data-selected', 'false').removeClass('active');
        // this.togglePreviewItemByIdIndexActive(item.data('id'), true);

        if (item.attr('data-selected') === 'false') {
            this.togglePreviewItemByIdIndexActive(item.data('id'), true);
        }

        if (item.attr('data-selected') === 'true') {
            this.togglePreviewItemByIdIndexActive(item.data('id'), false);
            popup.find(`input[name="selected_page_ids[]"][value="${item.data('id')}"]`).remove();
        }

        // else {
        //     popup.find('figure').attr('data-selected', 'false').removeClass('active');
        //     this.togglePreviewItemByIdIndexActive(item.data('id'), true);
        // }

        if (popup.find('figure[data-selected="true"]').length >= 1) return
    }

    addItem(item: object = {}) {
        if (!item) {
            item = {
                pageId: null,
                // isCover: false,
            }
        }
        this.items.push(item)
    }

    saveItems() {
        const items = jQuery(`#${this.generatorWrapperClass} .${this.itemClass}`);
        let tempItems: Array<any> = [];

        items.each((index, item) => {
            const $item = jQuery(item);

            tempItems.push({
                pageId: $item.find(`.${this.itemInputWrapperClass} input`).val(),
                // isCover: false,
            })
        })

        this.items = tempItems;
        this.saveInSessionStorage(this.storageNameSelectedPage, JSON.stringify(this.items));
    }

    reRenderItems() {
        const items = jQuery(`#${this.generatorWrapperClass} .${this.itemClass}`);

        if (items.length === 0) {
            jQuery(`#${this.generatorWrapperRowClass}`).attr('hidden', 'hidden')
        }

        items.each((index, item) => {
            const $item = jQuery(item);
            let title = `Seite ${index + 1}`

            // if (index === 0) {
            //     title += ' (Titel)';
            // }

            $item.find(`.${this.itemTitleClass} span:first-child`).text(title);
            $item.attr('data-index', index);
        })
    }

    async renderItems() {
        let itemsHtml: string = "";

        jQuery(`#${this.generatorWrapperClass}`).html(itemsHtml);

        if (this.items.length === 0 || !!!this.items) return;

        let index = 0;

        for (const item of this.items) {
            itemsHtml += await this.renderItem(item, index);
            index++;
        }

        jQuery(`#${this.generatorWrapperClass}`).html(itemsHtml)
        jQuery(`#${this.generatorWrapperRowClass}`).removeAttr('hidden')

        this.renderItemsThumbnails();

        this.saveItems()
    }

    async renderItem(item, index: number | null = 0) {
        if (index === null) {
            const tempItemsCount = this.items.length;
            index = tempItemsCount - 1;
        }

        let title = `${window.riedlBamoHaendlerConfig.translations.page ?? 'Seite'} ${index + 1}`

        // if (index === 0) {
        //     title += ' (Titel)';
        // }

        // Todo: Get image thumbnail from backend
        // const imageSrc = this.getImageThumbnailByIndex(item.pageId) ?? '';

        return `<div class="riedl-progen__item" data-index="${index}">
            <div class="riedl-progen__item__thumbnail">
                <img src="">
            </div>
            <div class="riedl-progen__item__title">
                <span>${title}</span>
                <span>
                    <button class="et_pb_button et_pb_bg_layout_light button--action button--circle button--only-icon button-icon--pencil riedl-progen__item__edit open-popup" data-popup-id="prospect-pages" data-popup-type="edit"></button>
                    <button class="et_pb_button et_pb_bg_layout_light button--action button--circle button--only-icon button-icon--trash riedl-progen__item__delete"></button>
                </span>
            </div>
            <div class="riedl-progen__item__input">
                <label for="prospect_page_id_input--${item.pageId}">${window.riedlBamoHaendlerConfig.translations.pageId ?? 'Seiten-ID'}</label>
                <input type="text" placeholder="ID eingeben" id="prospect_page_id_input--${item.pageId}" name="prospect_page_id[]" value="${item.pageId ?? ''}">
            </div>
            <div class="riedl-progen__item__handle">
                <span class="bm-portal-icon">
                    <span class="icon__icon bm-portal-icon--drag handle"></span>
                </span>
            </div>
        </div>`;
    }

    async renderItemsThumbnails() {
        const pageItems = jQuery(`.${this.itemClass}`);

        for (const item of pageItems) {
            // console.log('renderItemThumbnails() => item', item);

            const $item = jQuery(item);
            this.renderItemThumbnail($item);
        }
    }

    async renderItemThumbnail(itemRow) {
        const pageId = itemRow.find('input').val();
        const imageSrc = await this.getImageThumbnailByIndex(pageId);

        if (!imageSrc) {
            return;
        }

        itemRow.find('img').attr('src', imageSrc);
    }

    async getImageThumbnailByIndex(pageId) {
        // Todo: Load images from backend

        const postData = {
            action: 'riedl_prospect_generator_get_page_thumbnail',
            page_id: pageId
        };

        const response = await jQuery.ajax({
            url: window.riedlBamoHaendlerConfig.ajaxUrl,
            type: 'post',
            // contentType: "application/json; charset=utf-8",
            data: postData,
            // contentType: false,
            // processData: false
        });

        // console.log("TEST in getImageThumbnailByIndex(): response ajax call", response);
        // return "//placehold.co/100x120/?text=No+Image";
        return response.data.fileUrl;
    }

    async uploadLogo(event) {

        if (Helpers.isDebugMode()) {
            console.log('Execute uploadLogo()');
        }

        try {
            jQuery(`#riedl-progen__logo-upload__error`).attr('hidden', 'hidden');

            // const form = jQuery(event.currentTarget);
            const formInputLogo = jQuery(event.currentTarget)
            const form = formInputLogo.closest('form');
            // const submitButton = form.find(':submit');

            // let formData = new FormData(event.target);
            let formData = new FormData(form.get(0))
            // let formData = form.serializeArray()

            // submitButton.addClass('is-loading');

            jQuery(`#${this.generatePdfButtonId}`).addClass('disabled')

            const response = await jQuery.ajax({
                url: window.riedlBamoHaendlerConfig.ajaxUrl,
                type: 'post',
                data: formData,
                contentType: false,
                processData: false
            });

            if (Helpers.isDebugMode()) {
                console.log("TEST in uploadLogo(): response ajax call", response);
            }

            if (!response.success) {
                throw response;
            }

            const formInput = jQuery(`#${this.coverLogoInput}`);
            // const isUploadedInput = jQuery(`#${this.logoUploadedInputId}`);
            // const deleteLogoButton = jQuery(`#${this.coverLogoUploadDeleteButton}`);

            const reader = new FileReader();
            let imageBlob: string | ArrayBuffer = "";

            reader.onload = () => {
                const logoImageWrapper = jQuery(`.${this.coverLogoImageWrapperClass}`);
                const imgTag = logoImageWrapper.find('img');

                if (Helpers.isDebugMode()) {
                    console.log('uploadLogo() => logoImageWrapper', logoImageWrapper, 'imgTag', imgTag);
                }

                // @ts-ignore
                imgTag.attr('src', reader.result);
                // logoImageWrapper.removeAttr('hidden');

                if (Helpers.isDebugMode()) {
                    console.log('IMAGE', reader.result)
                }

                // @ts-ignore
                imageBlob = reader.result ?? "";

                // form.hide();
                // submitButton.removeClass('is-loading');

                jQuery(event.target).closest('.et_pb_button').removeClass(this.buttonLoadingClass);

                // deleteLogoButton.show();

                const logoFileName = response.data.file_name

                this.saveInSessionStorage(this.storageNameUploadedLogo, logoFileName);

                this.setUploadedLogo(logoFileName, imageBlob)

                // isUploadedInput.val('1');

                jQuery(`#${this.generatePdfButtonId}`).removeClass('disabled')
            }

            // @ts-ignore
            reader.readAsDataURL(formInput.get(0).files[0]);

            setTimeout(() => {
                form[0].reset();
            }, 2000);


            jQuery(event.target).closest('.et_pb_button').removeClass(this.buttonLoadingClass);

        } catch (error: any) {

            if (Helpers.isDebugMode()) {
                console.error('uploadLogo() => There was an error', error.responseText ?? error)
            }

            const form = jQuery(`#${this.coverLogoFormId}`);

            if (error.data && error.data.error) {
                jQuery(`#riedl-progen__logo-upload__error`).html(error.data.error)
                    .removeAttr('hidden');

                // @ts-ignore
                form[0].reset();
            }

            form.find(':submit').removeClass(this.buttonLoadingClass);
        }
    }

    setUploadedLogo(fileName, blob) {
        if (!fileName) {
            return;
        }

        // console.log('setUploadedLogo() => fileName', fileName, 'blob', blob)

        const logoUploadForm = jQuery(`#${this.coverLogoFormId}`);
        const logoIsUploadedInput = jQuery(`#${this.logoUploadedInputId}`);
        const logoImageWrapper = jQuery(`.${this.coverLogoImageWrapperClass}`);
        const logoImagePreview = logoImageWrapper.find('img');

        logoImageWrapper.removeAttr('hidden');

        if (blob) {
            logoImagePreview.attr('src', blob)
        }

        logoIsUploadedInput.val('1');

        logoUploadForm.find(':submit').removeClass('is-loading')
        logoUploadForm.hide();
    }

    onDeleteLogoButton(event) {

        if (Helpers.isDebugMode()) {
            console.log('Execute onDeleteLogoButton()');
        }

        try {
            const form = jQuery(`#${this.coverLogoFormId}`);
            // const deleteLogoButton = jQuery(`#${this.coverLogoUploadDeleteButton}`);
            const logoImageWrapper = jQuery(`.${this.coverLogoImageWrapperClass}`);
            const logoImagePreview = logoImageWrapper.find('img')
            const logoUploadedInput = jQuery(`#${this.logoUploadedInputId}`);

            logoImageWrapper.attr('hidden', 'hidden');
            logoImagePreview.attr('src', '')
            logoUploadedInput.val('0');

            // form.find(':submit').removeClass('is-loading')
            form.show();

            this.deleteSessionStorageKey(this.storageNameUploadedLogo);

        } catch (error: any) {
            if (Helpers.isDebugMode()) {
                console.error(error.responseText);
            }
        }
    }

    async resetGenerator(event) {
        event.preventDefault();

        try {
            const button = jQuery(event.currentTarget);

            if (Helpers.isDebugMode()) {
                console.log("Button clicked reset clicked", button);
            }

            button.addClass('is-loading');

            await this.deleteSessionStorageKey(this.storageNameSelectedPage);
            await this.onDeleteLogoButton(null)

            // Reset items
            this.items = [];
            jQuery(`#${this.generatorWrapperClass}`).html('');
            jQuery(`#${this.generatorWrapperRowClass}`).attr('hidden', 'hidden')

            jQuery(`#${this.downloadReadyAlertId}`).attr('hidden', 'hidden')
            jQuery(`#${this.downloadReadyAlertId}`).attr('hidden', 'hidden')
            jQuery(`#${this.startNewSectionId}`).attr('hidden', 'hidden')

            setTimeout(() => {
                button.removeClass('is-loading');

                const closePopupEvent = new Event('closePopup')
                // @ts-ignore
                document.querySelector('body').dispatchEvent(closePopupEvent)

            }, 2000);

        } catch (error: any) {

        }
    }

    async generatePdf(event) {
        const self = this;

        jQuery(event.currentTarget).addClass(this.buttonLoadingClass);

        jQuery(`#${this.downloadReadyAlertId}`).attr('hidden', 'hidden');
        jQuery(`#${this.downloadReadyAlertId}`).find('.is-loading').removeClass('is-loading');
        jQuery(`#${this.startNewSectionId}`).attr('hidden', 'hidden');

        // const submitButton = jQuery(event.currentTarget)
        const form = jQuery(`#${this.generatorWrapperClass}`);
        const pageIdInputs = form.find('input[name="prospect_page_id[]"]')
        // const pageIds = form.serialize();

        if (Helpers.isDebugMode()) {
            console.log('PAGE IDs', pageIdInputs);
        }

        // @ts-ignore
        const pageIds = jQuery.map(pageIdInputs, (input) => {
            // @ts-ignore
            return jQuery(input).val();
        });

        // console.log('generatePdf() => form', pageIds)
        // return;

        let logoName: string | null = null;

        if (jQuery(`#${this.logoUploadedInputId}`)?.val() === '1' && this.getFromSessionStorage(this.storageNameUploadedLogo)) {
            logoName = this.getFromSessionStorage(this.storageNameUploadedLogo);
        }

        if (Helpers.isDebugMode()) {
            console.log('LOGO-TEST: Logo', logoName);
        }

        // return;

        const formData = {
            action: 'riedl_prospect_generator_generate_pdf',
            logo_name: logoName,
            session_hash: jQuery('#riedl-progen__hash').val(),
            page_ids: pageIds
        };

        const response = await jQuery.ajax({
            url: window.riedlBamoHaendlerConfig.ajaxUrl,
            type: 'POST',
            data: formData,
            // contentType: false,
            // processData: false
        });

        if (Helpers.isDebugMode()) {
            console.log('generatePdf() => response', response);
        }

        if (!!response.success && response.success) {
            this.generatedPdfUrl = response.data.fileUrl;

            this.toggleGeneratePdfButton(true);
            this.toggleDownloadPdfButton(true);

            jQuery(`#${this.downloadReadyAlertId}`).removeAttr('hidden');

            jQuery(`#${this.downloadButtonId}`).attr('data-pdf', this.generatedPdfUrl);
            jQuery(`#${this.downloadJpgButtonId}`).attr('data-download', '/portal/prospekt-download');

            jQuery(`#${this.startNewSectionId}`).removeAttr('hidden');

            $('#pdf-preview').attr('src', this.generatedPdfUrl);
        }

        setTimeout(() => {
            jQuery(event.target).closest('.et_pb_button').removeClass(self.buttonLoadingClass);
        }, 1000);
    }

    async downloadProspect(event) {
        const self = this;

        jQuery(event.currentTarget).addClass(this.buttonLoadingClass);

        const elem = window.document.createElement('a');
        // elem.href = this.generatedPdfUrl;
        elem.href = jQuery(event.currentTarget).attr('data-pdf') ?? this.generatedPdfUrl;
        elem.target = '_blank';
        elem.download = 'AdolfRiedl_Bademodenprospekt.pdf';
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);

        this.toggleGeneratePdfButton(true);

        jQuery(event.currentTarget).removeClass(self.buttonLoadingClass);

        // setTimeout(() => {
        // }, 3000);
    }

    async downloadJpgImages(event) {
        const self = this;

        jQuery(event.currentTarget).addClass(this.buttonLoadingClass);

        const elem = window.document.createElement('a');
        elem.href = jQuery(event.currentTarget).attr('data-download') ?? '';
        elem.download = 'AdolfRiedl_Bademodenprospekt.zip';
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);

        this.toggleGeneratePdfButton(true);
        // setTimeout(() => {
        // }, 2000);

        setTimeout(() => {
            jQuery(`#${self.downloadJpgButtonId}`).removeClass(self.buttonLoadingClass);
        }, 6000)
    }

    async onPageItemEditClicked(event) {
        const button = jQuery(event.currentTarget);
        // const itemIndex = button.data('index');

        const itemRow = button.closest(`.${this.itemClass}`);
        const itemIndex = itemRow.data('index');

        if (Helpers.isDebugMode()) {
            console.warn('onPageItemEditClicked() => event', itemIndex, itemRow);
        }
    }

    async onPageItemDeleteClicked(event) {
        const button = jQuery(event.currentTarget);
        const itemRow = button.closest(`.${this.itemClass}`);
        const itemIndex = itemRow.data('index');

        this.items = this.items.filter((e, i) => i !== itemIndex);
        itemRow.remove();

        this.reRenderItems();

        if (this.items.length === 0) {
            this.toggleGeneratePdfButton(false);
            this.toggleDownloadPdfButton(false);
        }
    }

    async onPreviewPageClicked(event, isEditMode, popup, triggerButton, buttonPopupTypeAttr) {
        const item = jQuery(event.currentTarget);
        const itemIndex = item.attr('data-id');
        // const modalForm = jQuery(`#${this.pagesPreviewAddPageFormId}`);

        if (Helpers.isDebugMode()) {
            console.log('onPreviewPageClicked()');
        }

        if (!item.hasClass('active')) {
            this.togglePreviewItemByIdIndexActive(itemIndex, true);
            // item.addClass('active');
            // item.attr('data-selected', 'true');
            // modalForm.append(`<input type="hidden" id="selected_page_id_${itemIndex}" name="selected_page_ids[]" value="${itemIndex}" />`);
        } else {
            this.togglePreviewItemByIdIndexActive(itemIndex, false);
            // item.removeClass('active');
            // item.attr('data-selected', 'false');
            // modalForm.find(`input#selected_page_id_${itemIndex}`).remove();
        }

        const pageItems = item.closest('#prospect-pages-preview figure.active');

        if (Helpers.isDebugMode()) {
            console.warn('onPreviewPageClicked() => pageItems', pageItems, 'XXXXXX', this.selectedEditItemPageIdForModal);
        }

        if (isEditMode && pageItems.length === 1) {
            // const pageListItem = triggerButton.closest(`.${this.itemClass}`);
            // const pageListItemInput = pageListItem.find('input').val();
            const pagePreviewItems = jQuery(`#${this.pagesPreviewGridId} figure`)

            pagePreviewItems.attr('data-selected', 'false').removeClass('active');
            popup.find(`input[name="selected_page_ids[]"]`).remove();
            this.togglePreviewItemByIdIndexActive(item.attr('data-id'), true);
        }
    }

    async onAddPagesInModal(event) {
        // const button = jQuery(event.currentTarget);
        const form = jQuery(event.target);
        const submitButton = form.find('[type=submit]');
        const clickedItems = form.find('input[name="selected_page_ids[]"]');

        // Get Id
        const selectedPageIds = jQuery.map(clickedItems, (item) => {
            // @ts-ignore
            return jQuery(item).val();
        })

        if (submitButton.attr('data-is-edit') && submitButton.attr('data-is-edit') === 'true') {
            const itemRow = jQuery(`.${this.itemClass}[data-index="${this.selectedEditItemIndexForEditModal}"]`)
            const itemInput = itemRow.find('input');
            const itemInputValue = itemInput.val();

            if (Helpers.isDebugMode()) {
                console.warn('onAddPagesInModal() => itemRow', this.selectedEditItemIndexForEditModal, itemRow);
            }

            itemInput.val(selectedPageIds[0] ?? itemInputValue);

            this.renderItemThumbnail(itemRow);

        } else if (this.items.length > 0) {

            if (Helpers.isDebugMode()) {
                console.warn('Add items, this.items NOT empty');
            }

            // @ts-ignore
            for (const itemIndex of selectedPageIds) {
                // const index = selectedPageIds.indexOf(itemIndex);
                const newItemObject = {
                    pageId: itemIndex,
                };

                this.addItem(newItemObject);
                this.togglePreviewItemByIdIndexActive(itemIndex, false);

                const newItemHtml = await this.renderItem(newItemObject, null);
                // @ts-ignore
                jQuery(`#${this.generatorWrapperClass}`).append(newItemHtml)
                this.renderItemThumbnail(jQuery(`.${this.itemClass}[data-index="${this.items.length - 1}"]`));
            }

        } else {
            // Add items to list
            selectedPageIds.forEach((itemIndex, index) => {
                this.addItem({
                    pageId: itemIndex,
                });

                this.togglePreviewItemByIdIndexActive(itemIndex, false);
            })

            // Render list new
            this.renderItems();
        }

        this.toggleGeneratePdfButton(true);

        // Close popup
        jQuery(`#${this.pagesPreviewAddPageFormId} .close-popup`).trigger('click');
    }

    async onChangeModalSelectBrand(event, selectedBrandId = "") {

        if (selectedBrandId === "") {
            const clickedItem = jQuery(event.currentTarget);

            // @ts-ignore
            selectedBrandId = clickedItem.attr('data-brand-id');
            const selectButtonWrapper = clickedItem.closest(`.portal__select`);


            selectButtonWrapper.find('a').removeClass('selected');
            clickedItem.addClass('selected');

            selectButtonWrapper.find('.active-sorting').html(clickedItem.text());
        } else {
            const selectButtonWrapper = jQuery(`#${this.pagesPreviewSelectBrandDropdownId}`);

            selectButtonWrapper.closest('.portal__select').addClass('selected')
            selectButtonWrapper.find('a').removeClass('selected');

            const selectedBrand = selectButtonWrapper.find(`a[data-brand-id="${selectedBrandId}"]`);
            const brandName = selectedBrand.text();

            selectedBrand.addClass('selected');
            selectButtonWrapper.find('.active-sorting').text(brandName)
        }

        const brandWrapper = jQuery(`.${this.pagesPreviewBrandWrapperClass}[data-brand="${selectedBrandId}"]`);

        jQuery(`.${this.pagesPreviewBrandWrapperClass}`).attr('hidden', 'hidden');
        brandWrapper.removeAttr('hidden');
    }

    resetSelectPageModal() {
        const brandWrapperItems = jQuery(`.${this.pagesPreviewBrandWrapperClass}`);
        brandWrapperItems.attr('hidden', 'hidden');

        const selectButtonWrapper = jQuery(`#${this.pagesPreviewSelectBrandDropdownId}`);
        selectButtonWrapper.find('a').removeClass('selected');

        selectButtonWrapper
            .removeClass('active')
            .removeClass('selected')
        // @ts-ignore
        selectButtonWrapper.find('.active-sorting').text(selectButtonWrapper.find('.active-sorting').attr('data-default-text') ?? '');
    }

    togglePreviewItemByIdIndexActive(itemIndex, activate = true) {
        const $item = jQuery(`#${this.pagesPreviewGridId} .${this.pagesPreviewItemClass}[data-id="${itemIndex}"]`);
        const modalForm = jQuery(`#${this.pagesPreviewAddPageFormId}`);

        if (Helpers.isDebugMode()) {
            console.log('togglePreviewItemByIdIndexActive', $item);
        }

        if (activate) {
            $item.addClass('active');
            $item.attr('data-selected', 'true');
            modalForm.append(`<input type="hidden" id="selected_page_id_${itemIndex}" name="selected_page_ids[]" value="${itemIndex}" />`);
        } else {
            $item.removeClass('active');
            $item.attr('data-selected', 'false');
            modalForm.find(`input#selected_page_id_${itemIndex}`).remove();
        }
    }

    toggleGeneratePdfButton(activate = true) {
        const button = jQuery(`#${this.generatePdfButtonId}`)

        if (activate) {
            button.removeAttr('hidden')
        } else {
            button.attr('hidden', 'hidden')
        }
    }

    toggleDownloadPdfButton(activate = true) {
        const button = jQuery(`#${this.downloadButtonId}`)

        if (activate) {
            button.removeAttr('hidden')
        } else {
            button.attr('hidden', 'hidden')
        }
    }

    saveInSessionStorage(key: string, value: string) {
        const date = new Date();
        date.setTime(date.getTime() + (12 * 60 * 60 * 1000));
        let expires = "expires=" + date.toUTCString();
        document.cookie = key + "=" + value + ";" + expires + ";path=/";
        // window.sessionStorage.setItem(key, value);
    }

    getFromSessionStorage(key: string) {
        let name = key + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
        // return window.cookie.getItem(key);
    }

    deleteSessionStorageKey(key: string) {
        // window.cookie.removeItem(key);
        const path = '/';
        const domain = '';

        if (this.getFromSessionStorage(key)) {
            document.cookie = key + "=" +
                ((path) ? ";path=" + path : "") +
                ((domain) ? ";domain=" + domain : "") +
                ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
        }
    }
}
